import styled from 'styled-components'

const Container = styled.span`
  display: inline-block;
  margin: auto 0;
  border: 2px solid grey;
  width: 2rem;
  height: 2rem;
  /*pointer-events: none;*/
`

export default function Checkbox({ children, ...props }) {
  return (
    <Container {...props} >
      {children}
    </Container>
  );
};
